import { useMemo } from 'react';

const useFilteredPlantTasks = (plantTasks, activeFilter) => {
    return useMemo(() => {
        if (!activeFilter) return plantTasks;
        return plantTasks?.filter(plantTask => plantTask?.processType === activeFilter);
    }, [plantTasks, activeFilter]);
}

export default useFilteredPlantTasks;
